import React, { memo, forwardRef } from "react";
const SvgAlphabetX = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M20.37 18.88c.187.2.3.38.34.54a1.154 1.154 0 01-.24 1.22c-.213.227-.493.34-.84.34-.147 0-.307-.04-.48-.12-.16-.067-.353-.233-.58-.5l-2.56-3.12-2.66 3.16c-.213.253-.407.413-.58.48s-.327.1-.46.1c-.307 0-.567-.107-.78-.32a1.085 1.085 0 01-.32-.8c0-.12.027-.26.08-.42.053-.16.167-.333.34-.52l2.84-3.22-2.4-2.64c-.173-.187-.287-.353-.34-.5a1.18 1.18 0 01-.08-.4c0-.333.113-.607.34-.82.227-.213.5-.32.82-.32.147 0 .307.04.48.12.173.067.36.227.56.48l2.16 2.66 2.24-2.74c.173-.213.347-.353.52-.42.173-.067.327-.1.46-.1.307 0 .56.1.76.3.213.2.32.46.32.78 0 .107-.027.233-.08.38a1.642 1.642 0 01-.3.48l-2.42 2.74 2.86 3.18z"
      />
    </svg>
  );
});
SvgAlphabetX.displayName = "SvgAlphabetX";
const MemoForwardRef = memo(SvgAlphabetX);
export default MemoForwardRef;
